
     <form [formGroup]="formEdit" >
      <mat-dialog-content>
        <label>{{content}}</label>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <button mat-raised-button  (click)="save()">OK</button>
      </mat-dialog-actions>
    </form>
  